import { useState, useEffect } from "react";
import axios from "../context/axiosConfig";

/* ------------------------------------------------------------------ */
export default function ManipulationMaintenance({ onBack, onSelect, selected_plant_id }) {
  /* state that used to live in MaintenanceSelector ------------------- */
  const [selectedTechniques, setSelectedTechniques] = useState([]);
  const [plantCount, setPlantCount] = useState(0);
  const [techniqueOptions, setTechniqueOptions] = useState([]);
  const [loading, setLoading] = useState(true);
  
  // Check if we have multiple plants (from a plot)
  useEffect(() => {
    if (Array.isArray(selected_plant_id)) {
      setPlantCount(selected_plant_id.length);
      console.log(`Found ${selected_plant_id.length} plants for manipulation maintenance`);
    }
  }, [selected_plant_id]);
  
  const org_id = localStorage.getItem("organization");
  
  // Fetch technique options from lookup API
  useEffect(() => {
    const fetchTechniques = async () => {
      try {
        setLoading(true);
        const response = await axios.get(
          `/orgs/${org_id}/lookups/manipulation_technique?locale=en`,
          { withCredentials: true }
        );
        setTechniqueOptions(response.data);
        setLoading(false);
      } catch (err) {
        console.error("Error fetching manipulation techniques:", err);
        setLoading(false);
      }
    };
    
    fetchTechniques();
  }, [org_id]);
  
  const handleUpload = async () => {
    console.log('Selected plant ID:', selected_plant_id);
    try {
        // Validate inputs
        if (selectedTechniques.length === 0) {
            alert("Please select at least one technique");
            return;
        }
        
        // Create array of plant IDs
        const plantIds = Array.isArray(selected_plant_id) ? selected_plant_id : [selected_plant_id];
        
        // Convert selected technique IDs to integers
        const techniqueIds = selectedTechniques.map(id => parseInt(id));
        
        // Send a single request with the array of plant IDs and technique IDs
        const requestData = {
            techniqueid: techniqueIds,
            plant_id: plantIds
        };
        
        console.log('Sending request data:', requestData);
        
        await axios.post(
            `/orgs/${org_id}/maintenance/manipulation`,
            requestData,
            {
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
        alert('Upload complete');
        onBack && onBack(); // Return to previous screen after successful upload
    } catch (err) {
        console.error('Upload failed:', err);
        if (err.response?.status === 400) {
                alert('Upload failed - Check if all required fields are filled in correctly');
            } else if (err.response?.status === 401 || err.response?.status === 403) {
                alert("Upload failed - You are no longer logged in or you don't have access to this resource");
            } else if (err.response?.status === 500) {
                alert("Upload failed - Something went wrong in the service, please try again later");
            } else {
                alert(`Upload failed with error: ${err.response}`);
            }
    }
  };

  /* ------------------------------------------------------------------ */
  return (
    <>
        {/* header & back -------------------------------------------------- */}
        <div className="maintenanceHeader">
            <h3>Manipulation</h3>
            <button className="uploadMaintenanceBtn" onClick={handleUpload}>Upload</button>
        </div>

        <div className="maintenaceGrid maintenanceList">
            <div className="dropdownBlock">
        <div className="purpleBtn extraGridBtn blueBtn" onClick={onBack}>
          Back
        </div>
        </div>
            
            {plantCount > 1 && (
              <div className="plotMaintenanceNotice">
                Applying manipulation maintenance to all plants in plot ({plantCount} plants)
              </div>
            )}
            
            {loading ? (
              <div>Loading manipulation techniques...</div>
            ) : (
              <div className="checkbox-group">
                  {techniqueOptions.map((technique) => (
                      <label key={technique.id}>
                          <input
                              type="checkbox"
                              className="maintenanceCheckbox"
                              checked={selectedTechniques.includes(technique.id.toString())}
                              onChange={(e) =>
                                  setSelectedTechniques((s) =>
                                      e.target.checked
                                          ? [...s, technique.id.toString()]
                                          : s.filter((i) => i !== technique.id.toString())
                                  )
                              }
                          />
                          {technique.name}
                      </label>
                  ))}
              </div>
            )}

            <button
                type="button"
                className="clear-selection"
                onClick={() => setSelectedTechniques([])}
            >
                Clear
            </button>
        </div>
    </>
  );
}